import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { IoMdNotifications } from "react-icons/io";
import { useInAppNotifications } from "context/InAppNotificationContext";

const FloatingNotificationBell: React.FC = () => {
  const { unreadCount } = useInAppNotifications();
  const navigate = useNavigate();
  const location = useLocation();

  const layoutPrefix = location.pathname.startsWith("/systemadmin")
    ? "/systemadmin"
    : location.pathname.startsWith("/user")
      ? "/user"
      : "/admin";

  // Hide on auth pages
  if (location.pathname.startsWith("/auth") || location.pathname === "/first-login") {
    return null;
  }

  // Hide if already on notifications page
  if (location.pathname.endsWith("/notifications")) {
    return null;
  }

  return (
    <button
      onClick={() => navigate(`${layoutPrefix}/notifications`)}
      className="fixed bottom-20 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-brand-500 text-white shadow-lg transition-all hover:bg-brand-600 hover:shadow-xl active:scale-95"
      aria-label="Notifications"
    >
      <IoMdNotifications className="h-7 w-7" />
      {unreadCount > 0 && (
        <span className="absolute -right-1 -top-1 flex h-6 min-w-[24px] items-center justify-center rounded-full bg-red-500 px-1.5 text-xs font-bold text-white shadow">
          {unreadCount > 99 ? "99+" : unreadCount}
        </span>
      )}
    </button>
  );
};

export default FloatingNotificationBell;
